import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class Kind extends Field {
  static subqueriesForModel() {
    return { workflowKind: ['name'] };
  }

  get title() {
    return 'Type';
  }

  exampleContents(): FieldContentsData {
    return { text: 'New' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.workflowKind) {
      return { text: record.workflowKind.name };
    }

    return {};
  }
}
